<template>
  <div>
    <BarcodeReaderModal
      v-if="modalIsVisible"
      @close="closeBarcodeReader"
    />
    <button
      class="btn btn-primary"
      :disabled="isLoading"
      @click="modalIsVisible = true"
    >
      <i class="fa fa-fw fa-barcode" /> Сканировать
    </button>
  </div>
</template>

<script>
import BarcodeReaderModal from '@/stock/widgets/barcode/ReaderModal';
import { inventoryService } from '@/stock/api-services';
import { useNotification } from '@/_shared/mixins';
import store from "@/stock/store";
export default {
  mixins: [useNotification],
  components: {
    BarcodeReaderModal,
  },
  data() {
    return {
      modalIsVisible: false,
    };
  },
  computed: {
    isLoading() {
      return store.state.inventory.isLoading;
    },
    items() {
      return store.state.inventory.items;
    },
  },
  methods: {
    async closeBarcodeReader(barcode = '') {
      this.modalIsVisible = false;
      if (!barcode || this.newValuesWereChanged(barcode)) {
        return;
      }
      store.commit('inventory/setLoadStatus', true);
      await inventoryService.getMatchedItem(barcode)
        .then(({ data }) => {
          store.commit('inventory/setLoadStatus', false);
          if (data.record !== null) {
            const item = { ...data.record, new_value: 1 };
            return store.commit('inventory/addItem', item);
          }
          this.showErrorNotification(data.message);
        })
    },
    newValuesWereChanged(barcode) {
      let wasModified = false;
      const updatedItems = this.items.map((item) => {
        if (item.barcode === barcode) {
          wasModified = true;
          item.new_value++;
        }
        return item;
      });
      store.commit('inventory/updateItems', updatedItems);
      return wasModified;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/features/inventory/BarcodeButton.vue